function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(5,25,47,0.41);}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -85.333)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 85.333)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M18.2,85.333H2.116A2.119,2.119,0,0,0,0,87.449v9.311a2.119,2.119,0,0,0,2.116,2.116H18.2a2.119,2.119,0,0,0,2.116-2.116V87.449A2.119,2.119,0,0,0,18.2,85.333Zm1.27,11.428a1.271,1.271,0,0,1-1.27,1.27H2.116a1.271,1.271,0,0,1-1.27-1.27V87.449a1.271,1.271,0,0,1,1.27-1.27H18.2a1.271,1.271,0,0,1,1.27,1.27v9.311Z",
  transform: "translate(0 -85.333)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.693 87.026)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M59.526,128.185a.424.424,0,0,0-.588-.11L52,132.824a1.516,1.516,0,0,1-1.721,0l-6.942-4.75a.423.423,0,1,0-.477.7l6.942,4.75a2.355,2.355,0,0,0,2.677,0l6.942-4.75A.423.423,0,0,0,59.526,128.185Z",
  transform: "translate(-42.67 -128)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.692 92.105)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M48.474,256.148a.426.426,0,0,0-.6-.054L42.8,260.326a.424.424,0,0,0,.543.651l5.079-4.233A.424.424,0,0,0,48.474,256.148Z",
  transform: "translate(-42.646 -255.996)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.698 92.105)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M325.775,260.325l-5.079-4.232a.424.424,0,0,0-.543.651l5.079,4.233a.424.424,0,1,0,.543-.651Z",
  transform: "translate(-320.001 -255.995)"
}))));

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.316,
    height: 13.544,
    viewBox: "0 0 20.316 13.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8ef5b81a.svg";
export { ForwardRef as ReactComponent };